import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lodash from "lodash";

import FormSelect from "../FormUi/FormSelect";

class AssignUser extends React.Component {
  state = {
    users: [],
    selectedUsers: this.props.selectedUsers,
    deletedUserIssueIds: []
  };

  componentWillMount() {
    axios
      .get("/api/v1/employees.json?method=full_name&active=true&archived=false&issue_access=true")
      .then(({ data }) => {
        this.setState({ users: data });
      });
  }

  render() {
    const { selectedUsers, users, deletedUserIssueIds } = this.state;

    return (
      <div>
        <label htmlFor="newIssueId">Assigned To</label>
        <FormSelect
          _key="id"
          _val="full_name"
          name="user_id"
          dataValue={selectedUsers}
          options={users}
          urlSearch="/api/v1/employees.json?search={q}&method=full_name&issue_access=true"
          selectProps={{ isMulti: true }}
          onChange={this.handlerChange}
          selectId="newIssueId"
          styles={{
            placeholder: (base) => ({
              ...base,
              color: "#555",
            }),
          }}
        />

        {selectedUsers.map(selectedUser => (
          <div key={selectedUser.value}>
            <input
              type="hidden"
              name="issue[user_issues_attributes][][user_id]"
              value={selectedUser.value}
            />
            {selectedUser.id ? (
              <input
                type="hidden"
                name="issue[user_issues_attributes][][id]"
                value={selectedUser.id}
              />
            ) : null}
          </div>
        ))}

        {deletedUserIssueIds.map(userId => (
          <div key={userId}>
            <input
              type="hidden"
              name="issue[user_issues_attributes][][id]"
              value={userId}
            />
            <input
              type="hidden"
              name="issue[user_issues_attributes][][_destroy]"
              value="true"
            />
          </div>
        ))}
      </div>
    );
  }

  handlerChange = selectedUsers =>
    this.setState({ selectedUsers }, this.buildDeletedUserIds);

  buildDeletedUserIds = () => {
    const deletedUserIssueIds = [];
    lodash.forEach(this.props.selectedUsers, selectedUser => {
      const idx = lodash.findIndex(this.state.selectedUsers, {
        value: selectedUser.value
      });
      if (idx === -1) {
        deletedUserIssueIds.push(selectedUser.id);
      }
    });

    this.setState({ deletedUserIssueIds });
  };
}

AssignUser.propTypes = {
  selected: PropTypes.array
};

AssignUser.defaultProps = {
  selectedUsers: []
};

export default AssignUser;
